import "./HealthBar.css";

interface Props {
  value: number;
  max: number;
  /** Whose bar, for the label. */
  label: string;
  className?: string | undefined;
}

/** A chunky health bar that turns amber and then red as it drains. */
export function HealthBar({ value, max, label, className }: Props) {
  const share = max > 0 ? Math.max(0, Math.min(1, value / max)) : 0;
  const tone = share <= 0.25 ? " low" : share <= 0.5 ? " mid" : "";
  return (
    <div
      className={["hbar" + tone, className].filter(Boolean).join(" ")}
      role="progressbar"
      aria-label={`${label} health`}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={Math.max(0, value)}
      aria-valuetext={`${Math.max(0, value)} of ${max}`}
    >
      <div className="hbar-fill" style={{ width: `${share * 100}%` }} />
      <span className="hbar-num display" aria-hidden="true">
        {Math.max(0, value)}
      </span>
    </div>
  );
}
